import {createAuthClient} from 'better-auth/vue'
import {organizationClient} from 'better-auth/client/plugins'

function createLilalibaAuthClient(baseURL: string) {
    return createAuthClient({
        baseURL,
        basePath: '/api/auth',
        plugins: [
            organizationClient({
                teams: {
                    enabled: true,
                },
            }),
        ],
        fetchOptions: {
            credentials: 'include',
        },
    })
}

let browserClient: ReturnType<typeof createLilalibaAuthClient> | null = null
let browserClientBaseURL = ''

export function useAuthClient() {
    const baseURL = useApiBaseURL()

    if (import.meta.server) {
        return createLilalibaAuthClient(baseURL)
    }

    if (!browserClient || browserClientBaseURL !== baseURL) {
        browserClientBaseURL = baseURL
        browserClient = createLilalibaAuthClient(baseURL)
    }

    return browserClient
}
